"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[639],{

/***/ 2639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ RichTextSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2606);
/* harmony import */ var _lib_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(608);



function RichTextSection(param) {
    let { data: { title , html  }  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        size: _lib_types__WEBPACK_IMPORTED_MODULE_2__/* .ContainerSize.wide */ .B.wide,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "grid grid-cols-12 gap-1.5 md:gap-6",
            children: [
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "text-32 md:text-35 leading-130 font-bold text-blue-800 col-start-2 col-span-11 lg:col-start-4 lg:col-span-6",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-start-2 col-span-10 lg:col-start-4 lg:col-span-6 prose",
                    dangerouslySetInnerHTML: {
                        __html: html
                    }
                })
            ]
        })
    });
}


/***/ })

}]);